export const _en = {
    name: {
        label: "Label"
    },
    trainingCourseId: {
        label: "Training product"
    },
    startDate: {
        label: "Start date"
    },
    finishDate: {
        label: "Start date"
    },
    beginHour: {
        label: "Begin hour"
    },
    duration: {
        label: "Module duration"
    },
    isOffSyllabus: {
        label: "Off sylabus",
        tooltip: "Off sylabus day"
    }
};

export const _fr = {
    name: {
        label: "Libellé"
    },
    trainingCourseId: {
        label: "Modèle de stage"
    },
    startDate: {
        label: "Date et heure de début"
    },
    finishDate: {
        label: "Date et heure de fin"
    },
    beginHour: {
        label: "Heure de début par défaut"
    },
    duration: {
        label: "Durée du bloc par défaut"
    },
    isOffSyllabus: {
        label: "Hors syllabus",
        tooltip: "Module hors syllabus - planification dynamique"
    }

};